import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { AuthCallback } from "./auth-callback";
import "./styles.css";

// On the OAuth return path, render only the lightweight callback screen (which
// completes the PKCE exchange and forwards to `?next`) instead of the full site.
const isAuthCallback = window.location.pathname === "/auth/callback";

createRoot(document.getElementById("root")!).render(
  <StrictMode>{isAuthCallback ? <AuthCallback /> : <App />}</StrictMode>
);
